import type { ICampaignAnalytic } from '~/types/metric';

import { deepCopy } from './../../../utils/deepCopy';
import { create } from 'zustand';

export interface CacheDataValue {
  requestId?: string;
  data?: ICampaignAnalytic;
}
export type TCacheData = Record<string, CacheDataValue>;

export interface AnalyticMetricStoreState {
  cacheData: TCacheData;
  progress: number;
  isShowBannerProgress: boolean;
  dataKeyErrors: any[];
  setProgress: (progress: number) => void;
  upsertCacheData: (key: string, value: CacheDataValue) => void;
  getCacheData: () => TCacheData;
  setIsShowBannerProgress: (isShowBannerProgress: boolean) => void;
  setDataKeyErrors: (value: any[]) => void;
  checkAndDeleteDataKeyErrors: (value: any[]) => void;
}

export const useAnalyticMetricStore = create<AnalyticMetricStoreState>()((set, get) => ({
  cacheData: {},
  progress: 0,
  isShowBannerProgress: true,
  dataKeyErrors: [],
  upsertCacheData: (key, value) => {
    set((state) => {
      const currentCacheData = deepCopy(state.cacheData);
      const updatedCacheData = {
        ...currentCacheData,
        [key]: {
          requestId: currentCacheData[key]?.requestId ?? '',
          ...value,
        },
      };

      return {
        cacheData: updatedCacheData,
      };
    });
  },
  getCacheData: () => get().cacheData,
  setProgress: (progress) => set({ progress }),
  setIsShowBannerProgress: (isShowBannerProgress) => set({ isShowBannerProgress }),
  setDataKeyErrors: (value: any[]) => {
    set((state) => {
      const dataKeyErrors = deepCopy(state.dataKeyErrors);
      const isExisting =
        dataKeyErrors.findIndex((item) => JSON.stringify(item) === JSON.stringify(value)) > -1;
      if (!isExisting) {
        dataKeyErrors.push(value);
      }

      return {
        dataKeyErrors,
      };
    });
  },
  checkAndDeleteDataKeyErrors: (value: any[]) => {
    set((state) => {
      const dataKeyErrors = deepCopy(state.dataKeyErrors);
      const index = dataKeyErrors.findIndex(
        (item) => JSON.stringify(item) === JSON.stringify(value),
      );
      if (index > -1) {
        dataKeyErrors.splice(index, 1);
      }

      return {
        dataKeyErrors,
      };
    });
  },
}));
